import { useScrollRestoration } from '../hooks/useScrollRestoration';

/**
 * ScrollToTop component that manages scroll behavior on navigation.
 * Must be placed inside Router but outside Routes.
 *
 * Behavior:
 * - On forward navigation (PUSH): scrolls to top
 * - On back/forward navigation (POP): restores previous scroll position
 * - Saves scroll positions in sessionStorage keyed by history entry
 */
function ScrollToTop() {
  useScrollRestoration();
  return null;
}

export default ScrollToTop;
